import { render, staticRenderFns } from "./AgreeTerms.vue?vue&type=template&id=d9fed222&scoped=true&"
import script from "./AgreeTerms.vue?vue&type=script&lang=js&"
export * from "./AgreeTerms.vue?vue&type=script&lang=js&"
import style0 from "./AgreeTerms.vue?vue&type=style&index=0&id=d9fed222&prod&lang=scss&scoped=true&"
import style1 from "./AgreeTerms.vue?vue&type=style&index=1&id=d9fed222&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fed222",
  null
  
)

export default component.exports